module.exports = __webpack_public_path__ + "static/media/dashboard-logo-icon.86c664d4.svg";